import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrFollowUpForwardGet, SrFollowUpService } from '@app/services/sr-follow-up.service';

@Component({
    selector: 'tt-sr-follow-up-forward',
    templateUrl: './sr-follow-up-forward.component.html',
    styleUrls: ['./sr-follow-up-forward.component.css'],
    standalone: false,
})
export class SrFollowUpForwardComponent implements OnInit {
    public page?: SrFollowUpForwardGet;
    public resources: Item[] = [];
    public sending = false;
    public error = '';
    constructor(private readonly followUp: SrFollowUpService, private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    public async ngOnInit(): Promise<void> {
        try {
            this.page = await this.followUp.getForward({ experience_keyno: String(this.navigator?.params['experience_keyno'] ?? '') });
            if (this.page.experience_keyno?.trim()) {
                this.resources = [];
                this.resources = await this.followUp.getForwardResources({ experience_keyno: this.page.experience_keyno });
            }
        } catch (error) { this.showError(error); }
    }
    public async send(): Promise<void> {
        if (!this.page || this.sending) return;
        this.sending = true;
        this.error = '';
        try {
            const response = await this.followUp.sendForward(this.page);
            if (response.errorcode !== '0') await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage,
                buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
            else { this.sending = false; await this.navigator?.back(); }
        } catch (error) { this.showError(error); }
        finally { this.sending = false; }
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
